// Need to match values in styles/01-settings/scss/breakpoints
export const breakpoints = {
	xs: 360,
	sm: 768,
	md: 1024,
	lg: 1320,
	xl: 1600,
};

export type BreakpointTypes = keyof typeof breakpoints;
